import {
  convertJSONToArray,
  getItemLocalStorage,
  select,
  svgIcon,
} from "@utils/function";

export default function ScheduleTennis() {
  // console.log("schedule", HQ.Properties.schedule);
  const scheduleContent = select(".schedule-content .slider-content");

  // clear all content
  scheduleContent.textContent = "";

  if (scheduleContent) {
    const createContainer = document.createElement("div");
    createContainer.classList.add("container");
    createContainer.classList.add("schedule-locator");
    createContainer.classList.add("tennis-flag");
    scheduleContent.insertAdjacentElement("beforeend", createContainer);

    Object.entries(HQ.Properties.schedule).forEach(([key, value]) => {
      // header for daily schedule
      const headerDailySchedule = createHeader(key, value);
      createContainer.insertAdjacentHTML("beforeend", headerDailySchedule);

      // body for daily schedule
      const bodyDailySchedule = createBody(value);
      createContainer.insertAdjacentHTML("beforeend", bodyDailySchedule);
    });
  }
}

/**
 * Create header
 *
 * @param {string} key
 * @param {object} value
 * @returns string
 */
function createHeader(key, value) {
  const arrayValue = convertJSONToArray(value);
  const { DisplayTime } = arrayValue[0];
  const { court } = value[key] ?? {};

  let liveElement = "";
  if (value[1]?.hasOwnProperty("live")) {
    liveElement = true;
  }

  const infoPlayer = liveElement ? createPlayingIcon() : "";

  // NOTE: if court is null, then return empty string
  // example: 1677599222.json don't have court name
  // json format is wrong

  const displayTime = DisplayTime
    ? `
      <div class="row schedule-follow-by-locator">
        <div class="d-flex">
          <span>${DisplayTime}</span> ${infoPlayer}
        </div>
      </div>`
    : "";

  const headerTemplate = `
    <div class="row schedule-court-name-locator">
      <span class="fw-bold">${court?.CourtName ?? ""}</span>
    </div>
    ${displayTime}
  `;

  return headerTemplate;
}

/**
 * Create playing icon
 */
function createPlayingIcon() {
  return `<span class="col ps-0 schedule-icon-header">(${svgIcon({
    color: "#000",
    name: "icon-tennis-playing",
  })} = playing)</span>`;
}

/**
 * Create body
 *
 * @param {object} value
 * @returns string
 */
function createBody(value) {
  const arrayValue = convertJSONToArray(value);

  const bodyRow = arrayValue
    .map((item, index) => {
      const playerRow = createPlayerRow(item);

      const { DisplayTime } = item;
      const bodyTemplateHeader = `${DisplayTime}`;

      const liveElement = item.hasOwnProperty("live");

      const infoPlayer = liveElement ? createPlayingIcon() : "";

      let RowTemplate =
        index > 0
          ? `
            <div class="row schedule-follow-by-locator">
              <span class="col-auto">${bodyTemplateHeader}</span> ${infoPlayer}
            </div>`
          : "";

      return RowTemplate + playerRow;
    })
    .join("");

  return bodyRow;
}

/**
 * Create player row
 *
 * @param {object} item
 * @returns string
 */
function createPlayerRow(item) {
  if (!item) return;
  const { Player, Partner, Opponent, OpponentPartner } = item || {};

  const player = JSON.parse(Player);
  const partner = JSON.parse(Partner);
  const opponent = JSON.parse(Opponent);
  const opponentPartner = JSON.parse(OpponentPartner);

  let playersID = "";

  // -----------------------------------
  // player
  let playerRow = "";
  if (Player) {
    playerRow = rowPlayer(Player, "left");
    playersID = player ? player?.PlayerId : "";
  }

  // -----------------------------------
  // partner
  let partnerRow = "";

  if (Partner) {
    partnerRow = rowPlayer(Partner, "left");
    playersID += partner ? `,${partner?.PlayerId}` : "";
  }

  // -----------------------------------
  // opponent
  let opponentRow = "";
  if (Opponent) {
    opponentRow = rowPlayer(Opponent, "right");
    playersID += opponent ? `,${opponent?.PlayerId}` : "";
  }

  // -----------------------------------
  // opponent partner
  let opponentPartnerRow = "";
  if (OpponentPartner) {
    opponentPartnerRow = rowPlayer(OpponentPartner, "right");
    playersID += opponentPartner ? `,${opponentPartner?.PlayerId}` : "";
  }

  // check if live element exist in object
  const liveElement = item.hasOwnProperty("live");

  // score column
  const scoreColumn = liveElement
    ? getScoreLive(item) ?? "-"
    : getDailySchedule(item) ?? "-";

  // add cursor pointer if live
  const liveStyle = liveElement ? "schedule-live cursor-pointer" : "";

  // place id
  const placeId = liveElement ? `data-place-id="${item.court.place_id}"` : "";

  // data tracking name
  let playersName = getPlayersName(item);

  const dataTrackingName = `data-tracking-name="${playersName}"`;

  // open court (show court detail)
  const openCourt = liveElement ? "open-court" : "";

  const column = liveElement ? "col-2" : "col-3";

  // icon player
  const iconPlayer = liveElement
    ? `<div class="col-1 tennis-plays text-center"><svg fill="#000"><use href="#icon-tennis-playing"></use></svg></div>`
    : "";

  const hasFavoritePlayer = checkFavoritePlayer(playersID)
    ? "favorite-player"
    : "";

  // player row div
  const playerRowDiv = `
    <div ${placeId} ${dataTrackingName} class="container p-0 flex-column ${liveStyle} ${openCourt}">
      <div class="row align-items-center ${hasFavoritePlayer}">
        <div class="col-4 py-0 ps-2">${playerRow}${partnerRow ?? ""}</div>
        <div class="col-1 schedule-vs">vs</div>
        <div class="col-4 pe-2">${opponentRow}${opponentPartnerRow ?? ""}</div>
        <div class="${column}">
          <div class="schedule-points">
            ${scoreColumn}
          </div>
        </div>
        ${iconPlayer}
      </div>
    </div>
  `;

  return playerRowDiv;
}

/**
 * Check if favorite player in local storage
 */
function checkFavoritePlayer(playersID) {
  const arrayPlayersID = playersID.split(",");

  const getFavoritePlayer = getItemLocalStorage("HQfavoritePlayers");

  // elements from arrayPlayersID find in getFavoritePlayer
  const favoritePlayer = arrayPlayersID.filter((item) =>
    getFavoritePlayer.includes(item)
  );

  return favoritePlayer.length > 0 ? true : false;
}

/**
 * Generate player row
 *
 * @param {object} player
 * @param {string} place
 */
function rowPlayer(player, place) {
  const playerObj = JSON.parse(player);

  if (!playerObj) return;

  let {
    PlayerFirstName: firstName,
    PlayerLastName: lastName,
    PlayerId: id,
    Country: country,
  } = playerObj;

  firstName = firstName ? firstName.slice(0, 1) + ". " : "";

  // const reverse = place === "right" ? "flex-row-reverse" : "";
  //  ${reverse}

  const playerTemplate = `
    <div class="schedule-player d-flex gap-2 align-items-center">
      <div title="${country}" class="col-2 flag-icon flag-icon-${country?.toLowerCase()}"></div>
      <div class="col-10">${firstName}${lastName}</div>
    </div>
  `;

  return playerTemplate;
}

/**
 * Get players name
 *
 * @param {object} player
 * @returns string
 */
function getPlayersName(player) {
  let playersName = "";

  Object.entries(player).forEach(([key, value]) => {
    if (key == "live") {
      if (value.hasOwnProperty("PlayerTeam")) {
        playersName = getFirstAndLastName(value.PlayerTeam);
      }

      if (value.hasOwnProperty("OpponentTeam")) {
        playersName += ", " + getFirstAndLastName(value.OpponentTeam);
      }
    }
  });

  return playersName;
}

/**
 * Get first and last name
 *
 * @param {object} player
 * @returns string
 */
function getFirstAndLastName(player) {
  const playerObj = JSON.parse(player);

  let { PlayerFirstName: firstName, PlayerLastName: lastName } =
    playerObj.Player;

  firstName = firstName ? firstName.slice(0, 1) + ". " : "";

  return `${firstName}${lastName}`;
}

/**
 * Get score
 *
 * @param {object} item
 */
function getScoreLive(item) {
  if (!item.hasOwnProperty("live")) return;

  const { PlayerTeam, OpponentTeam } = item.live;
  const { GameScore: gameScorePlayer, SetScores: setScorePlayer } =
    JSON.parse(PlayerTeam);
  const { GameScore: gameScoreOpponent, SetScores: setScoreOpponent } =
    JSON.parse(OpponentTeam);

  const scoreTemplate = `
    ${createTemplateRow(gameScorePlayer, setScorePlayer)}
    ${createTemplateRow(gameScoreOpponent, setScoreOpponent)}
  `;

  return scoreTemplate;
}

/**
 * Create template row
 *
 * @param {*} game
 * @param {*} score
 * @returns
 */
function createTemplateRow(game, score) {
  const gameRow = game ? `<div class="col">${game}</div>` : "";

  return `
    <div class="row">
      <div class="d-flex p-0 text-center">
        ${gameRow}
        ${createRow(score)}
      </div>
    </div>
  `;
}

/**
 * Create score row
 *
 * @param {object} score
 */
function createRow(score) {
  return score
    .map((obj) => {
      const { SetScore } = obj;

      return SetScore ? `<div class="col">${SetScore}</div>` : "";
    })
    .join("");
}

/**
 * Get daily schedule
 *
 * @param {object} item
 * @returns string
 */
function getDailySchedule(item) {
  if (!item.ResultString) return;

  let result = item.ResultString;

  // replace ( and ) with <sup> and </sup>
  const supText = result.replace(/(\(|\))/g, (m) =>
    m === "(" ? "<sup>(" : ")</sup>"
  );

  // create array from string
  const arrayResult = supText.split(" ");

  // add alements from array to div

  const resultDiv = arrayResult
    .map((item) => {
      if (item === "(") {
        return "<sup>(";
      } else if (item === ")") {
        return ")</sup>";
      } else {
        return `<div class="col">${item}</div>`;
      }
    })
    .join("");

  const template = `
    <div class="row">
      <div class="d-flex p-0 text-center">
        ${resultDiv}
      </div>
    </div>
  `;

  return template;
}
